module.exports = __webpack_public_path__ + "static/default_dog-eb426d416fd2270cc4fd23c62a155ad1.png";